export const sliceNames = Object.freeze({
    LOGIN: "login",
    GLOBAL: "global",
})
